import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../PromptGenerator.module.css';

interface ProgressIndicatorProps {
  currentIndex: number;
  totalQuestions: number;
}

const ProgressIndicator: React.FC<ProgressIndicatorProps> = ({
  currentIndex,
  totalQuestions
}) => {
  const { t } = useTranslation('promptGenerator');
  
  return (
    <div className={styles.progressContainer}>
      <div className={styles.progressBar}>
        <div 
          className={styles.progressFill}
          style={{ width: `${((currentIndex + 1) / totalQuestions) * 100}%` }}
        />
      </div>
      <span className={styles.progressText}>
        {t('promptGenerator.progress.step')} {currentIndex + 1} {t('promptGenerator.progress.of')} {totalQuestions}
      </span>
    </div>
  );
};

export default ProgressIndicator;
